"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.p2 = void 0;
// 32-bit powers of two wouldn't be possible with <<
exports.p2 = [];
for (var i = 0; i < 32; i++)
    exports.p2[i] = Math.pow(2, i);
